import React from 'react';

import './widget.style.css';

const widget = ({ title = null, flexGrow = 1, stretch = false, children = null }) => {
    const flexStyle = {
        flexGrow,
        width: 0,
    };
    const stretchStyle = {};
    if (stretch) {
        stretchStyle.height = '100%';
    }

    return (
        <div style={flexStyle} className="Widget">
            <div className="WidgetContainer" style={stretchStyle}>
                {title ? <div className="WidgetHeader">{title}</div> : null}
                <div className="WidgetContent">{children}</div>
            </div>
        </div>
    );
};

export default widget;
